export default {
  SIGNED_UP_USERS_GET_REQUEST: "SIGNED_UP_USERS_GET_REQUEST",
  SIGNED_UP_USERS_GET_RECEIVE: "SIGNED_UP_USERS_GET_RECEIVE",
  SIGNED_UP_USERS_GET_ERROR: "SIGNED_UP_USERS_GET_ERROR",
  SEND_EMAIL_POST_REQUEST: "SEND_EMAIL_POST_REQUEST",
  SEND_EMAIL_POST_RECEIVE: "SEND_EMAIL_POST_RECEIVE",
  SEND_EMAIL_POST_ERROR: "SEND_EMAIL_POST_ERROR"
};
